<div class="mapView" #mapView></div>

<!-- ==================================== -->
<!-- POPUP OF DETAILS -->
<!-- ==================================== -->
<div class="overlay" *ngIf="showOverlayPopup">
    <div class="popup">
      <div class="colse-popup" (click)="poenAndHideOverliyPopup()">
        <img src="../../../assets/images/closeIcon.svg" />
      </div>
      <div class="popup-title">
        <p>تفاصيل</p>
      </div>
      <div class="popup-img">
        <img src="../../../assets/images/popupImg.svg" />
      </div>
      <div class="popup-text">
        <p style="margin-bottom: 30px">
          هذا مثال لنص يمكن أن يستبدل في نفس المساحة هذا مثال لنص يمكن أن يستبدل
          في نفس المساحة هذا مثال لنص يمكن أن يستبدل في نفس المساحة هذا مثال لنص
          يمكن أن يستبدل في نفس المساحة
        </p>
        <p>
          هذا مثال لنص يمكن أن يستبدل في نفس المساحة هذا مثال لنص يمكن أن يستبدل
          في نفس المساحة هذا مثال لنص يمكن أن يستبدل في نفس المساحة هذا مثال لنص
          يمكن أن يستبدل في نفس المساحة
        </p>
      </div>
    </div>
  </div>
  
  <!-- ================================ -->
  <!-- START RIGHT MENU BAR -->
  <!-- ================================ -->
  <!-- HAND ICON -->
  <button class="btns btn-hand mov" (click)="panToHand()">
    <img src="../../../assets/images/handIcon.svg" />
  </button>
  <!-- HOME ICON -->
  <button class="btns btn-home mov" (click)="zoomToHome()">
    <img src="../../../assets/images/homeIcon.svg" />
  </button>
  <!-- PREV ICON -->
  <button class="btns btn-prev mov " id="zoomPrevBtn" (click)="zoomToPreviousExtent()"> <!--esri-widget--button esri-widget esri-disabled-->
    <img src="../../../assets/images/prevIcon.svg" />
  </button>
  <!-- NEXT ICON -->
  <button class="btns btn-next mov " id="zoomNextBtn" (click)="zoomToNextExtent()"> <!--esri-widget--button esri-widget esri-disabled-->
    <img src="../../../assets/images/nextIcon.svg" />
  </button>
  <!-- LAYERS ICON -->
  <button class="btns btn-layers mov" (click)="openLayerPopup()">
    <img src="../../../assets/images/layerIcon.svg" />
  </button>
  <!-- SWITCH MAP ICON -->
  <button class="btns btn-switch-map mov" (click)="openSwitchMapPopup()">
    <img src="../../../assets/images/switchMapIcon.svg" />
  </button>
  <!-- DETAILS ICON -->
  <button class="btns btn-details mov" (click)="poenDetailsPopup()">
    <img src="../../../assets/images/detailsIcon.svg" />
  </button>
  <!-- ================================ -->
  <!-- END RIGHT MENU BAR -->
  <!-- ================================ -->
  